import { render } from "./UpdateContentPage.vue?vue&type=template&id=755e322e&ts=true"
import script from "./UpdateContentPage.vue?vue&type=script&lang=ts"
export * from "./UpdateContentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Contents/UpdateContentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "755e322e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('755e322e', __exports__)) {
    api.reload('755e322e', __exports__)
  }
  
  module.hot.accept("./UpdateContentPage.vue?vue&type=template&id=755e322e&ts=true", () => {
    api.rerender('755e322e', render)
  })

}


export default __exports__